import axios from '@/axios/globalaxios'

export const findQuotationByCondition = data =>{
    return axios({
        url: "/tradelab/marketPortfolioManagement/findQuotationByCondition",
        method: 'post',
        data:data
    })
}
